import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from 'components/ui/dialog';
import { PlanIncluded } from 'features/subscription/components/subscription-plan';
import { PlanSeats, seatPriceLabel } from 'features/subscription/utils/seat-pools';

interface PlanDetailsDialogProps {
  /** Null closes the dialog. */
  entry: PlanSeats | null;
  onClose: () => void;
}

/** What one seat on a plan gives its holder, the same list the plans page shows. */
export const PlanDetailsDialog = ({ entry, onClose }: PlanDetailsDialogProps) => {
  const { t } = useTranslation();
  const price = entry ? seatPriceLabel(t, entry, true) : '';
  // The backend stores one description per plan, so PLAN_DESCRIPTION_<CODE> translates it.
  const description = entry?.plan?.description
    ? t(`PLAN_DESCRIPTION_${entry.plan.code.toUpperCase().replace(/-/g, '_')}`, entry.plan.description)
    : t('PLAN_DETAILS_DESCRIPTION', 'What each seat on this plan includes.');

  return (
    <Dialog open={!!entry?.plan} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[480px]">
        <DialogHeader>
          <DialogTitle>{entry?.name}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        {price && <p className="text-sm font-medium">{price}</p>}
        {entry?.plan && (
          <div className="flex flex-col">
            <PlanIncluded plan={entry.plan} />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
